import { useEffect, useState } from "react";
import { Dumbbell } from "lucide-react";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const SplashScreen = () => {
  const [phase, setPhase] = useState(isStandalone() ? "show" : "hidden");

  // Les deux minuteurs sont armes une seule fois, au montage. Avec [phase] en
  // dependance, le passage a « fade » relancait l'effet : son nettoyage
  // annulait t2 avant qu'il ne s'execute, et le splash restait monte a
  // opacity-0 par-dessus l'application — invisible, mais captant chaque
  // touche. Ne rien lire de reactif ici : la liste vide doit rester vide.
  useEffect(() => {
    if (!isStandalone()) return;
    const t1 = setTimeout(() => setPhase("fade"), 1600);
    const t2 = setTimeout(() => setPhase("hidden"), 2100);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (phase === "hidden") return null;

  return (
    <div data-testid="splash-screen"
      className={`fixed inset-0 z-[200] bg-[#0A0A0A] flex flex-col items-center justify-center transition-opacity duration-500 ${
        phase === "fade" ? "opacity-0 pointer-events-none" : "opacity-100"}`}>
      <div className="w-20 h-20 bg-[#FF3B30] flex items-center justify-center animate-[splashPop_.6s_ease-out]">
        <Dumbbell size={44} className="text-white" />
      </div>
      <h1 className="font-display text-5xl text-white mt-6 tracking-wide animate-[splashPop_.6s_ease-out_.15s_both]">
        GYM<span className="text-[#FF3B30]">TRACK</span>
      </h1>
      <p className="text-[#B0B0B4] text-xs uppercase tracking-[0.3em] mt-3 animate-[splashPop_.6s_ease-out_.3s_both]">
        Chaque série à l'échec
      </p>
      <div className="absolute bottom-12 w-24 h-[3px] bg-[#14141A] overflow-hidden">
        <div className="h-full bg-[#FF3B30] animate-[splashBar_1.4s_ease-in-out_forwards]" />
      </div>
    </div>
  );
};
